import { render, staticRenderFns } from "./PointReportingList.vue?vue&type=template&id=526f5ae9&"
import script from "./PointReportingList.vue?vue&type=script&lang=js&"
export * from "./PointReportingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports